import { render } from "./BarcodeManagement.vue?vue&type=template&id=6f626c98"
import script from "./BarcodeManagement.vue?vue&type=script&lang=js"
export * from "./BarcodeManagement.vue?vue&type=script&lang=js"
script.render = render

export default script